const parseTemplate = (template, obj, seperator = "$") => {
  let msg = template;

  if (typeof msg !== "string") return "";
  Object.keys(obj).forEach((key) => {
    msg = msg.replace(
      new RegExp(`\\${seperator}\\${seperator}${key}`, "g"),
      obj[key],
    );
  });
  return msg;
};

export default parseTemplate;
